import AsyncComputed from 'vue-async-computed';

/* eslint-disable max-lines-per-function */
export default class Search {

	/**
	 * @type {import('./api').SearchClient}
	 */
	static client;

	static app;

	static isLoaded = false;

	static async create ({defaultSearchParams, categoryCode, filters, query, segment, tag}) {

		const {SearchClient} = await import('./api');
		const {default: Vue} = await import('vue');
		const {default: VueRouter} = await import('vue-router');
		const {default: VueLazyload} = await import('vue-lazyload');
		const {rallyHouseFilters} = await import('./data/bgfilters');

		// Create data obj
		this.data = {};

		// Create client instance
		this.client = new SearchClient(defaultSearchParams, !categoryCode);

		// Apply Bgfilters
		rallyHouseFilters(this.client);

		// Apply search filters
		if (filters) {
			for (const filter of filters) {
				if (Array.isArray(filter.value)) {
					for (const value of filter.value) {
						this.client.backgroundFilter(filter.field, decodeURIComponent(value));
					}
				}
				else {
					this.client.backgroundFilter(filter.field, decodeURIComponent(filter.value));
				}
			}
		}

		// Apply category if defined
		if (categoryCode) {
			this.client.category(categoryCode);
		}

		// Apply query if defined
		if (query) {
			this.client.query(query);
		}

		// Add catalog segment
		if (segment) {
			this.client.segment(segment);
		}

		// Add search tag
		if (tag) {
			this.client.other('tag', tag);
		}

		// Lock state -- allowing us to reset to this baseline later
		this.client.lock();

		// ====================================================

		const {default: SearchApp} = await import('./components/search/SearchApp');
		const {default: toCurrency} = await import('./filters/toCurrency');
		const {default: rewriteUrl} = await import('./filters/rewriteUrl');

		// Plugins
		Vue.use(VueRouter);
		Vue.use(VueLazyload, {
			attempt: 1
		});
		Vue.use(AsyncComputed);

		// Filters
		Vue.filter('toCurrency', toCurrency);
		Vue.filter('rewriteUrl', rewriteUrl);

		const router = new VueRouter({
			base: '/',
			mode: 'history',
			scrollBehavior () {
				if (!Search.isLoaded)
				{
					return false;
				}

				return {
					behavior: 'smooth',
					x: 0,
					y: 0
				};
			}
		});

		// Create new Vue app
		this.app = new Vue({
			el: '#search-main',
			render (createElement) {
				return createElement(SearchApp);
			},
			router: router
		});

	}

}
